import { useLocation } from 'react-router';

import { getMatchingRoute } from 'src/app/pages/petition/shared/routes';
import type { SubRoute } from 'src/app/pages/petition/shared/routes';

export function useCurrentRoute(): SubRoute | undefined {
	const location = useLocation();
	return getMatchingRoute(location.pathname);
}
